/**
 * Maps the bulk-self-schedule context into the `POST /ats_schedules/bulk`
 * payload shape:
 *
 *   ats_application_ids: number[]   // multi-candidate target list
 *   is_bulk_activity:    true       // queues a `BulkActivities::BulkActivityWorker`
 *                                   // — see backend audit memory
 *   source_job_id:       number     // the job the candidates were selected from
 *
 * `applyContextIdsForMode` is responsible for stripping the
 * single-candidate `ats_application_id` / `candidate_id` fields when
 * mode is `bulk-self-schedule` — see `mapDetails.ts`. This file only
 * adds the bulk-specific keys; the two helpers compose in
 * `buildPayload`.
 */
import type { BulkSelfScheduleContextIds } from './types';

export function mapBulkSelfScheduleContext(
  bulk: BulkSelfScheduleContextIds
): Record<string, unknown> {
  return {
    ats_application_ids: bulk.applicationIds,
    is_bulk_activity: true,
    source_job_id: bulk.sourceJobId,
  };
}
